<template>
    <DataTable v-redirect-if-no-permission:TYPES :url="api.ACTIONS.CAR_BRANDS"
               :titles="titles"
               :fieldsHiddenMain="['deleted_at']"
               :fieldsHiddenAdd="['id','created_at','deleted_at','updated_at']"
               :fieldsDisabledEdit="['id','created_at','deleted_at','updated_at']"
               :actionsExtraMain="actionsExtraMain"
               title="Car Brands"
               :fieldsExtraAdd="fieldsExtraAdd"
    />
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "CarBrands",
        title: 'Brands',
        components: {DataTable},
        computed: {
            titles() {
                return {
                    id: "#",
                    name: "Name",
                    created_at: "Created At",
                    updated_at: "Updated At"
                }
            },
            fieldsExtraAdd() {
                return {
                    name: "v-text-field"
                }
            },
            actionsExtraMain() {
                return {
                    models: {
                        title: "Models",
                        color: "secondary",
                        action: (item) =>
                            this.$router.push({
                                name: "CarBrandModels",
                                params: {"id": item.id},
                                query: {"name": item.name},
                            })
                    },
                }
            }
        }
    }
</script>

<style scoped>

</style>